<se-fe-alert
  seFeDataType="info">
  Financial Admin UI Library
  <se-fe-alert-subheader>
    This is the library app!
  </se-fe-alert-subheader>
</se-fe-alert>
